import type { ExtensionsCommandFactory } from '../ExtensionsModel';

export const hideExtensionDetailsDialog: ExtensionsCommandFactory<never> =
  (cmdContext) => async () => {
    cmdContext.updateState((draft) => {
      draft.readonlyExtensionDialogOpen = false;
    });
  };
